import HttpService from './HttpService';
import { statsToLiveeFormat } from 'polle-shared-formatters';
import { flatten, propOr } from 'ramda';

/**
 * Resolve unique user inentifier. POL-55.
 * For registered users, we use ChatEndUserID, as long after cookies cleaning or login from another browser
 * we can have multiple ChatUserID for the same user.
 * For anonymous users ChatEndUserID always null, so we can use only ChatUserID.
 * Also convert to number, because in some cases (in answers) we have string.
 */
export const resolveUID = (obj) => {
  const chatUserID = Number(obj.ChatUserID) || 0;
  const chatEndUserID = Number(obj.ChatEndUserID) || 0;
  return chatEndUserID > 0 ? chatEndUserID : chatUserID;
}

const getContestStatsPerQuestion = contestStats => {
  return flatten(contestStats.PerQuestion || []).map(question => {
    return {
      questionId: question.QuestionID,
      uid: resolveUID(question),
      score: question.Score,
      lastVoteAt: question.LatestVoteTime,
      answers: Object.values(question.Answers).map(answer => {
        return {
          voteId: answer.VoteID,
          uid: resolveUID(answer),
          questionId: answer.QuestionID,
          answerId: answer.AnswerID,
          answerRank: answer.AnswerRank,
          voteTime: answer.VoteTime,
          nickName: answer.NickName,
          login: answer.Login,
          firstName: answer.FirstName,
          lastName: answer.LastName,
          email: answer.Email,
          photo: answer.Photo
        };
      })
    };
  });
};

class PollService extends HttpService {
  constructor() {
    super();
  }

  findOfPoll(pollId) {
    return this.http
      .get(`/api/poll/${pollId}/stats`)
      .then(this.onResponse)
      .then(({ data: { Stats } }) => {
        const constestStats = Stats.ContestStats || {};
        const stats = {
          contestStats: {
            perUser: (constestStats.PerUser || []).map(vote => {
              return {
                uid: resolveUID(vote),
                lastVoteAt: vote.LatestVoteTime,
                totalScore: vote.TotalScore
              };
            }),
            perQuestion: getContestStatsPerQuestion(constestStats)
          }
        };
        return { ...stats, ...statsToLiveeFormat(Stats) }
      })
      .catch(this.onError);
  }
}

export default new PollService();
